'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import { X, Clock } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

export default function TrialExpiryBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed || !user) return null;
  if (user.subscriptionStatus !== 'trialing' || !user.currentPeriodEnd) return null;

  const daysLeft = Math.ceil((new Date(user.currentPeriodEnd).getTime() - Date.now()) / (24 * 60 * 60 * 1000));
  if (daysLeft > 3 || daysLeft < 0) return null;

  return (
    <div className="bg-amber-500/10 border-b border-amber-500/20 px-4 py-2 flex items-center justify-center gap-3 text-sm">
      <Clock size={14} className="text-amber-400 flex-shrink-0" />
      <span className="text-amber-200">
        Your Pro trial expires in <strong>{daysLeft}</strong> day{daysLeft !== 1 ? 's' : ''}.
      </span>
      <Link
        href="/pro"
        className="text-amber-400 hover:text-amber-300 font-semibold underline underline-offset-2 transition-colors"
      >
        Upgrade now
      </Link>
      <button
        onClick={() => setDismissed(true)}
        className="ml-2 p-0.5 text-amber-500/60 hover:text-amber-300 transition-colors"
      >
        <X size={14} />
      </button>
    </div>
  );
}
